<!-- 保养项 -->
<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/maintain/bill/item/page" getKey="rows" :columns="columns" @afterGet="afterGet">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.editObj" class="demo-form-inline">
          <el-form-item :label="$t('baoyangdanhao')" class="noborder">
            <el-input disabled v-model="$attrs.maintainItem.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" class="noborder">
            <!-- {{$attrs.maintainItem.equipment.name==null?$attrs.maintainItem.equipment.name:""}} -->
            <el-input disabled v-model="$attrs.maintainItem.equipment.name"></el-input> </el-form-item><br />
          <el-form-item :label="$t('baoyangfangshi')" class="noborder">
            <el-input disabled :value="$t(store.state.dictJson['EQUIPMENT_MAINTAIN_MODE'][$attrs.maintainItem.mode])"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baoyangpingjia')" v-if="$attrs.maintainItem.comment == null">
            <el-input v-model="yt.editObj.comment" type="text"></el-input>
          </el-form-item>
          <el-button :loading="yt.editObj.loading" v-if="$attrs.maintainItem.comment == null" size="mini" @click="yt.editObj.id = $attrs.maintainItem.id;
          yt.req('POST', '/web/equipment/maintain/bill/addComment', null, addComment);">{{ $t('baocun') }}</el-button>
        </el-form>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline" v-if="$attrs.maintainItem.comment != null">
          <el-form-item :label="$t('baoyangpingjia')">
            {{ $attrs.maintainItem.comment }}
          </el-form-item>
        </el-form>

        <div v-if="utils.checkPower('web_equipment_maintenance_update_image') && $attrs.maintainItem.status !== 3">
          <yi_upload ref="up" accept=".bmp,.gif,.jpg,.jpeg,.png" btName="shangchuantupian" :ids.sync="imageIds" :limit="5" @afterUpload="afterUpload" @afterRemove="afterRemove">
            <template slot="limitMsg">
              <span></span>
            </template>
          </yi_upload>
        </div>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-button type="text" @click="
      yt.editObj = scope.row;
    yt.req('POST', '/web/equipment/maintain/bill/item/start', null, refresh);
    " :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备保养-开始保养' } }">
              {{ $t('kaishibaoyang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 2">
            <el-button type="text" :loading="yt.editObj.loading" @click="finish(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备保养-完成保养' } }">
              {{ $t('wanchengbaoyang') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" :loading="yt.editObj.loading" @click="
      yt.editObj.id = $attrs.maintainItem.id;
    yt.req('POST', '/web/equipment/maintain/bill/oneKeyStart', null, refresh);
    " type="primary" v-if="!isAllStarted" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备保养-一键开始' } }">
          {{ $t('yijiankaishi') }}
        </el-button>
        <el-button size="mini" :loading="yt.editObj.loading" @click="finishAll" type="primary" v-if="!isAllFinish" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备保养-一键完成' } }">
          {{ $t('yijianwancheng') }}
        </el-button>
      </template>
      <template #beizhu="scope">
        <div>
          <span v-show="scope.row.status != 2">{{ scope.row.remark }}</span>
          <el-input v-show="scope.row.status == 2" size="small" v-model="scope.row.remark"></el-input>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_equipment_maintenance_maintenance_list_item',
  data() {
    return {
      // 已上传的图片id
      imageIds: [],
      // 图片上传是否结束
      isUploadFinish: false,
      fixConditions: {
        billId: this.$attrs.maintainItem.id
      },
      columns: [
        {
          label: 'baoyangbuwei',
          prop: 'part',
          width: 130
        },
        {
          label: 'baoyangneirong',
          prop: 'content'
        },
        {
          label: 'zhuyishixiang',
          prop: 'attention'
        },
        {
          label: 'baoyangzhouqi',
          prop: 'cycle'
        },
        {
          label: 'shangcibaoyangshijian',
          prop: 'lastMaintainTime',
          type: 'time',
          width: 180
        },
        {
          label: 'shengchengguize',
          prop: 'generationRules',
          type: 'dictionary',
          key: 'MAINTENANCE_ORDER_GENERATION_RULES',
          width: 150
        },
        {
          label: 'baoyangzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('weibaoyang')
            },
            2: {
              color: '#E6A23C',
              text: this.$t('baoyangzhong')
            },
            3: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            }
          }
        },
        {
          label: 'caozuoren',
          prop: 'operator.nickname',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          type: 'slot',
          width: 200
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    this.imageIds = this.$attrs.maintainItem.fileIdList;
    setTimeout(() => {
      this.yt.conditions = {
        billId: this.$attrs.maintainItem.id
      };
      this.yt.isShowPagination = true;
      this.yt.get(1);
    }, 300);
  },
  computed: {
    isAllStarted() {
      if (this.yt.list) {
        for (let i = 0; i < this.yt.list.length; i++) {
          if (this.yt.list[i].status == '1') {
            return false;
          }
        }
        return true;
      }
    },
    isAllFinish() {
      if (this.yt.list) {
        for (let i = 0; i < this.yt.list.length; i++) {
          if (this.yt.list[i].status != '3' && this.yt.list[i].status != '1') {
            return false;
          }
        }
        return true;
      }
    }
  },
  methods: {
    afterGet(){
      for (let i = 0; i < this.yt.list.length; i++) {
        if(this.yt.list[i].status == '2') {
          this.$set(this.yt.list[i], 'remark', this.yt.list[i].remark || '');
        }
      }
    },
    // 文件上传之后调用
    afterUpload() {
      setTimeout(() => {
        if (!this.$refs.up.loading && !this.isUploadFinish) {
          this.isUploadFinish = true;
          // 更新图片id
          this.http
            .post('/web/equipment/maintain/bill/update/fileIds', {
              id: this.$attrs.maintainItem.id,
              fileIdList: this.imageIds
            })
            .then(res => {
              this.$message.success(this.$t(res.msg));
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            }).finally(() => {
              this.isUploadFinish = false;
            });
        }
      }, 1000);
    },
    // 文件移除之后调用
    afterRemove() {
      console.log('afterRemove imageIds', this.imageIds);
      // 更新图片id
      this.http
        .post('/web/equipment/maintain/bill/update/fileIds', {
          id: this.$attrs.maintainItem.id,
          fileIdList: this.imageIds
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    finish(row){
      if(row.remark && row.remark.length > 100){
        this.$message.error(this.$t('beizhuchangduzuidawei')+'100');
        return;
      }
      this.yt.editObj = row;
      this.yt.req('POST', '/web/equipment/maintain/bill/item/finish', null, this.finishAfter);
    },
    finishAll(){
      this.yt.editObj.id = this.$attrs.maintainItem.id;
      this.yt.req('POST', '/web/equipment/maintain/bill/oneKeyFinish', null, this.finishAfter);
    },
    finishAfter(res) {
      if (res.data) {
        this.$attrs.maintainItem.status = 3;
      }
      this.refresh();
    },
    refresh() {
      this.yt.get();
      this.utils.event_hub.$emit('BASE_MAINTENANCE_REFRESH');
    },
    addComment() {
      this.$attrs.maintainItem.comment = this.yt.editObj.comment;
      this.yt.get();
      this.utils.event_hub.$emit('BASE_MAINTENANCE_REFRESH');
    }
  }
};
</script>

<style></style>
